import {
  BASE_URL, LAST_UPDATE_TIME, NOTI_TIMEOUT, SET_TICKER_INFO, SOCKET_SUBSCRIBE, SOCKET_UNSUBSCRIBE, TOGGLE_HIDE_UNHIDE,
  UPDATE_FONT_SIZE
} from './types';
import axios from "axios";
import {NotificationManager} from "react-notifications";

export function toggleHideUnhide() {
  return {
    type: TOGGLE_HIDE_UNHIDE
  };
}

export function setWeightColor( tickerWeightRed, tickerWeightGreen ) {
  const url = `${BASE_URL()}/api/setWeightColor`;
  const request = axios.post(url, { tickerWeightRed, tickerWeightGreen }, {
    headers: { authorization: localStorage.getItem('token') }
  })
  return (dispatch) => {
    request.then((response) => {
      dispatch({ type: SET_TICKER_INFO, payload: response });
      dispatch({ type: LAST_UPDATE_TIME });
    }).catch(() => {
      NotificationManager.error(`There was an error`, 'Error!', NOTI_TIMEOUT);
    });
  };
}

export function updateFontSize(payload) {
  localStorage.setItem('fontSize', payload);
  return {
    type: UPDATE_FONT_SIZE,
    payload: payload
  };
}